import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import { PairChallenge } from '@era/locations-sdk';

import { AsyncPipe } from '@angular/common';
import { ErrorModel } from '@era/app';
import { PairingRouterStoreSelectors } from '@era/stores';
import { ProgressModule } from '@layout-lib';
import { EnvironmentService } from '@methylium/core';
import { PairingChallengeComponent } from './pairing-challenge.component';
import {
  PairingStoreActions,
  PairingStoreSelectors,
  PairingStoreStates,
} from '../../sub-features/device-pairing/pairing-store';

@Component({
  selector: 'era-pairing-challenge',
  templateUrl: './pairing-challenge.container.html',
  styleUrls: ['./pairing-challenge.container.scss'],
  imports: [PairingChallengeComponent, ProgressModule, AsyncPipe],
})
export class PairingChallengeContainerComponent implements OnInit, OnDestroy {
  public readonly isVerifyingCode$: Observable<boolean>;
  public readonly isCodeInvalid$: Observable<boolean>;
  public readonly isEnrolling$: Observable<boolean>;
  public readonly isEnrollCompleted$: Observable<boolean>;
  public readonly pairingChallenge$: Observable<PairChallenge>;
  public readonly error$: Observable<ErrorModel>;

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly store: Store<PairingStoreStates.State>,
    public readonly environmentService: EnvironmentService
  ) {
    this.isVerifyingCode$ = this.store.select(PairingStoreSelectors.isVerifyingCode);
    this.isCodeInvalid$ = this.store.select(PairingStoreSelectors.isCodeInvalid);
    this.isEnrolling$ = this.store.select(PairingStoreSelectors.isEnrolling);
    this.isEnrollCompleted$ = this.store.select(PairingStoreSelectors.isEnrollmentCompleted);
    this.pairingChallenge$ = this.store.select(PairingStoreSelectors.selectPairChallenge);
    this.error$ = this.store.select(PairingStoreSelectors.selectError);
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.store.select(PairingRouterStoreSelectors.selectPairingCode).subscribe((pairingCode) => {
        this.store.dispatch(PairingStoreActions.PairConfirmContainerActions.verifyCodeRequested({ code: pairingCode }));
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }

  enroll(challenge: PairChallenge) {
    this.store.dispatch(
      PairingStoreActions.PairConfirmContainerActions.enrollmentRequested({ challenge: challenge.challenge })
    );
  }

  get ca(): string {
    if (this.environmentService.environment.local) {
      const url = new URL(`${this.environmentService.environment.mdm.api as string}/ca`);
      url.hostname = window.location.hostname;
      return url.href;
    }
    return '';
  }
}
